var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71424 5.1147V2.51189L7.42835 1.59784V4.15937L5.71424 5.1147V5.1147Z",
    fill: "url(#paint0_linear_690_2510)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61449 6.04456L4.633 8.24367L4.57146 8.27775L2.26485 7.00754V6.04456H4.61449V6.04456Z",
    fill: "url(#paint1_linear_690_2510)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71452 6.35181V7.64243L4.57162 8.27777V6.35181H5.71452V6.35181Z",
    fill: "url(#paint2_linear_690_2510)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44909 4.45433L3.44979 4.45479L3.40675 5.74541L3.99463 6.07236L1.69241 7.35556L1.6584 7.33585L1.64915 4.79426L3.99902 3.46677V4.12854L3.44909 4.45433V4.45433Z",
    fill: "url(#paint3_linear_690_2510)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69306 4.79285L0 3.8519V2.56128L1.73817 3.48484L1.69306 4.79285Z",
    fill: "url(#paint4_linear_690_2510)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9998 4.4664L5.71424 5.69534V7.02747L8.00003 5.75725V4.4664H7.9998Z",
    fill: "url(#paint5_linear_690_2510)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.550102 4.13901L1.693 4.79452V7.35605L0.550102 6.70008V4.13901V4.13901Z",
    fill: "#29F6A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40693 5.74587V4.45525L3.42266 4.44528L5.71354 5.69602V7.02815L3.40693 5.74587V5.74587Z",
    fill: "url(#paint6_linear_690_2510)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30754 3.81992L0 2.5613L2.30754 1.30267V3.81992Z",
    fill: "url(#paint7_linear_690_2510)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 4.4664L5.71423 5.73685L3.40693 4.45411L4.00036 4.12299L3.99573 4.12531L4.57134 4.44576L5.70313 3.8146L5.71423 3.19595L8.00002 4.46663V4.4664Z",
    fill: "url(#paint8_linear_690_2510)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00047 3.50897L4.00094 3.5085L3.97294 3.52381L2.83976 2.9047L2.26485 3.24045V0.635329L2.34119 0.592896L4.61449 1.90554L4.59945 4.44366L4.57169 4.46685L3.99608 4.12599L4.00047 3.50897V3.50897Z",
    fill: "url(#paint9_linear_690_2510)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79465 1.55008H3.15043V5.46368H7.79465V1.55008Z",
    fill: "url(#pattern0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57077 4.45896V1.90554L4.54578 1.89163L5.70256 1.2644L5.71343 1.2702V3.822L4.57077 4.45896Z",
    fill: "url(#paint10_linear_690_2510)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0003 3.50847L1.693 4.79445L0.550102 4.13871L2.83936 2.86316L4.0003 3.50847V3.50847Z",
    fill: "url(#paint11_linear_690_2510)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71424 2.55341V1.27021L6.28569 0.942566L7.42858 1.59831L5.71424 2.55364V2.55341Z",
    fill: "url(#paint12_linear_690_2510)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.26485 0.63534L4.57146 1.90556L5.71435 1.27022L3.40774 0L2.26485 0.63534Z",
    fill: "#76FF0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_690_2510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_690_2510",
    x1: 6.51774,
    y1: 1.97093,
    x2: 6.61999,
    y2: 4.79609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B368"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_690_2510",
    x1: 2.26485,
    y1: 7.16104,
    x2: 4.63323,
    y2: 7.16104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECD59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16DE3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_690_2510",
    x1: 5.14307,
    y1: 6.18857,
    x2: 5.14307,
    y2: 8.19499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007649"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_690_2510",
    x1: 4.66625,
    y1: 5.16966,
    x2: 2.55587,
    y2: 5.46885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#007258"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_690_2510",
    x1: 0.858096,
    y1: 3.02132,
    x2: 0.88366,
    y2: 4.63193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12C951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_690_2510",
    x1: 5.71401,
    y1: 5.74728,
    x2: 7.99957,
    y2: 5.74728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_690_2510",
    x1: 4.7511,
    y1: 4.76226,
    x2: 4.4725,
    y2: 6.28778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44E28D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10E2AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_690_2510",
    x1: 0,
    y1: 2.56106,
    x2: 2.30731,
    y2: 2.56106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64F562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_690_2510",
    x1: 3.40647,
    y1: 4.46663,
    x2: 7.99979,
    y2: 4.46663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DE2AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_690_2510",
    x1: 3.42579,
    y1: 1.24632,
    x2: 3.45182,
    y2: 3.82177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03E168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05C35E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_690_2510",
    x1: 4.65221,
    y1: 1.79702,
    x2: 5.42996,
    y2: 3.60462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00837B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03824D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_690_2510",
    x1: 1.13867,
    y1: 4.48699,
    x2: 3.2536,
    y2: 3.17026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52F171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_690_2510",
    x1: 5.67422,
    y1: 2.10728,
    x2: 6.73824,
    y2: 1.25561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11E2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#8DFE40"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_690_2510",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAABeCAYAAADG1PFrAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEleLogo);
export default __webpack_public_path__ + "static/media/ele-logo.1c5399e200c0ea63b71cfb6514a02382.svg";
export { ForwardRef as ReactComponent };